import { BasicFilterSelect, BaseOption } from 'ui/selects';

type ListSelectProps = {
  selectOption: (selectId: string) => void;
  listOptions: BaseOption<string>[];
  isLoading: boolean;
  defaultName?: string;
};

export const displayContent = {
  search: 'Search all lists',
  placeholder: 'Select a list',
};

export const ListSelect = ({
  selectOption,
  listOptions,
  isLoading,
  defaultName,
}: ListSelectProps) => {
  const inputContent = {
    filterPlaceholder: displayContent.search,
    triggerPlaceholder: displayContent.placeholder,
  };

  return (
    <BasicFilterSelect
      autoFocusOnInput
      shouldFocusOnFirstElementByDefault={false}
      data-test="list-add-select"
      defaultValue={defaultName}
      id="list-select"
      isDisabled={isLoading}
      options={listOptions}
      onSelect={(currentSelectedId) => {
        selectOption(currentSelectedId[0] as string);
      }}
      inputContent={inputContent}
      isFullWidth
    />
  );
};
